module.exports = __webpack_public_path__ + "img/Sunglasses01.6aa444c7.png";